module.exports = __webpack_public_path__ + "static/media/logo-green-2x.3365abba.png";